import React, { Component } from "react";
import { Dropdown, Modal, Button } from "semantic-ui-react";
import allAxiosCommonTA from "../axiosComponent/allAxiosCommonTA";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import cogoToast from "cogo-toast";

export class RemarksModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      remarks: '',
    };
  }

  handleOpenModal = () => {
    this.setState({ open: true });
  };

  saveSuggestedVendor = () => {
    let orderID = this.props.data.vendor_order_id;
    allAxiosCommonTA({
      url: `/orders/${orderID}`,
      method: "patch",
      Items: { remarks: this.state.remarks },
    })
      .then((response) => {
        cogoToast.success(response.data.message)
        setTimeout(() => {
          window.location.reload();
        }, 500);

      })
      .catch((err) => {
        console.log("err", err);
      });
    this.setState({ open: false });
  }

  remarksChange = (e) => {
    this.setState({ remarks: e.target.value })
  }

  render() {
    return (
      <>
        <div title={this.props.value} onClick={() => this.handleOpenModal()}>{this.props.data.remarks ? this.props.data.remarks : "-"}</div>

        <Modal
          onClose={() => this.setState({ open: false })}
          size='mini'
          open={this.state.open}
        >
          <Modal.Header>Remarks</Modal.Header>
          <Modal.Content style={{ paddingBottom: '200px' }}>
            <label className="labelName mt-2">
              Remarks
            </label>
            <div className="d-flex">
              <input type='textArea' placeholder={this.props.data.remarks} onChange={(e) => this.remarksChange(e)} style={{ width: '700px', height: '25px' }}></input>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button basic onClick={this.saveSuggestedVendor}>
              Save
            </Button>
            <Button basic onClick={() => this.setState({ open: false })}>
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

export default RemarksModal;
